// Packages
import React from "react";

// Controller
import useControllers from "../../../controllers";

// Components
import useComponents from "..";

// Styles
import {
  StyledNavBar,
  StyledNavBarHeader,
  StyledNavBarContent,
  StyleNavBarMenu,
  StyleNavBarItem,
  StyledButtonNabvar,
  StyledAccordionContent,
  StyledAccordionHeader,
  StyledAccordionBody,
} from "./NavBar.styles";

// Assets
import useIcons from "../../../assets/icons";

const NavBar = () => {
  const {
    IconLogo,
    IconArrowLeft,
    IconAccordionArrowDown,
    IconAccordionArrowUp,
    IconDashboard,
    IconMissions,
    IconResults,
    IconPayments,
    IconBell,
    IconMembeers,
    IconSupport,
    IconSettings
  } = useIcons();

  const { useComponentHooks } = useControllers();
  const { useNavBar } = useComponentHooks();
  const {
    handledButton,
    statusNavBar,
    navBarItems,
    elementActive,
    handleClickElement,
    handleNavigationToSubItems,
    handleNavigateTo,
    currentPath,
  } = useNavBar();
  const { Typography } = useComponents();

  // Map icon names to components
  const iconMap = {
    IconDashboard,
    IconMissions,
    IconResults,
    IconPayments,
    IconBell,
    IconMembeers,
    IconSupport,
    IconSettings
  };

  const getIconComponent = (iconName, isActive) => {
    const IconComponent = iconMap[iconName];
    if (!IconComponent) return null;

    // Active icons use primary golden color to match selected state
    const color = isActive ? "#FFB62A" : "#000000";
    return <IconComponent color={color} />;
  };

  const isNotEmpty = (subItems) => {
    return subItems?.length > 0;
  };

  return (
    <StyledNavBar status={statusNavBar}>
      <StyledNavBarHeader status={statusNavBar}>
        <span className="mr-2">
          <IconLogo />
        </span>
        {statusNavBar ? <Typography>Membeer</Typography> : null}
      </StyledNavBarHeader>
      <StyledNavBarContent status={statusNavBar}>
        <StyledButtonNabvar
          onClick={handledButton}
          status={statusNavBar}
          firstActive={navBarItems[0]?.name === elementActive}
        >
          <IconArrowLeft color={navBarItems[0]?.name === elementActive ? "#FFB62A" : "#000000"} />
          <IconArrowLeft color={navBarItems[0]?.name === elementActive ? "#FFB62A" : "#000000"} />
        </StyledButtonNabvar>
        <StyleNavBarMenu>
          {navBarItems?.map((item, index) => {
            return (
              <StyledAccordionContent
                key={index}
                expanded={item.name === elementActive}
                onClick={() => handleClickElement(item.name)}
              >
                <StyledAccordionHeader>
                  <span onClick={() => handleNavigateTo(item)}>
                    <span className="icon">
                      {getIconComponent(item.icon, item.name === elementActive)}
                    </span>
                    {statusNavBar && (
                      <>
                        <span>{item.name}</span>
                        {isNotEmpty(item?.optionSuboption) ? (
                          <span>
                            {item.name === elementActive ? (
                              <IconAccordionArrowUp color="#000000" />
                            ) : (
                              <IconAccordionArrowDown color="#000000" />
                            )}
                          </span>
                        ) : null}
                      </>
                    )}
                  </span>
                </StyledAccordionHeader>
                {isNotEmpty(item?.optionSuboption) ? (
                  <StyledAccordionBody className={!statusNavBar ? "contracted" : ""}>
                    {item.optionSuboption.map((subItem, index) => (
                      <StyleNavBarItem key={index} statusNavBar={statusNavBar}>
                        <span
                          onClick={() => handleNavigationToSubItems(subItem, item)}
                          className={
                            currentPath.startsWith(subItem.url) ? "active" : ""
                          }
                        >
                          <span>{subItem.name}</span>
                        </span>
                      </StyleNavBarItem>
                    ))}
                  </StyledAccordionBody>
                ) : null}
              </StyledAccordionContent>
            );
          })}
        </StyleNavBarMenu>
      </StyledNavBarContent>
    </StyledNavBar>
  );
};

export default NavBar;
